import { useMemo } from "react";
import { QueryStatus } from "@tanstack/react-query";
import { BillAccrualMatchSummary } from "@common/schemas/domains/accrualReview/accrual-review.schema";
import { useBillAccrualMatchSummaries } from "@api/bill.api";
import { useAccrualMatchSummaryMap } from "@components/accounting/transactionMatch/useAccrualMatchSummaryMap";

export interface BillMatchTableOptions {
    accrualMatchSummaries: Map<string, BillAccrualMatchSummary>;
    accrualMatchSummariesStatus: QueryStatus;
    readonly?: boolean;
}

const getBillSummaryId = (summary: BillAccrualMatchSummary) => summary.billId;

export function useBillMatchTableOptions({
    billIds,
    isMatchColumnVisible,
}: {
    billIds: string[];
    isMatchColumnVisible: boolean;
}): BillMatchTableOptions {
    const summariesQuery = useBillAccrualMatchSummaries({
        billIds,
        enabled: isMatchColumnVisible,
    });
    const accrualMatchSummaries = useAccrualMatchSummaryMap({
        summaries: summariesQuery.data,
        getDocumentId: getBillSummaryId,
    });
    return useMemo(
        () => ({
            accrualMatchSummaries,
            accrualMatchSummariesStatus: summariesQuery.status,
        }),
        [accrualMatchSummaries, summariesQuery.status],
    );
}
